export default __webpack_public_path__ + "static/headerphone-looped-b7c91c7ab4b77f8b8f4e2e61362f3102.mp4";